import QuestionnaireShell from "./QuestionnaireShell";

const sections = [
    {
        title: "Session Preparation",
        description: "Helps us plan your 1-hour Samvad consultation.",
        questions: [
            { id: "preferred_datetime", label: "Preferred consultation date/time" },
            { id: "platform", label: "Preferred platform", notes: "Zoom / Google Meet / Phone" },
            { id: "niti_filled", label: "Have you filled the Niti Questionnaire?", notes: "Required before session" },
        ],
    },
    {
        title: "Priority Topics for Discussion",
        questions: [
            { id: "top_questions", label: "Top 3 questions you want answered in this session", type: "textarea" },
            { id: "urgent_debt", label: "Any specific debt you need urgent help with?", type: "textarea" },
            { id: "settlement_interest", label: "Interested in an introduction to our legal team for debt settlement?", notes: "They can help settle debts with banks/NBFCs for as low as 35% of total debt · Legal fee 5% · Case-by-case basis" },
            { id: "budget_rebuild", label: "Want a complete monthly budget rebuild? (Yes / No)" },
            { id: "income_diversification", label: "Want income diversification ideas? (Yes / No)" },
            { id: "legal_concerns", label: "Any legal concerns about your debt?", notes: "Notices, threats, harassment" },
        ],
    },
    {
        title: "Documents You'll Keep Ready",
        description: "Just confirm you can pull these out during the call.",
        questions: [
            { id: "salary_slip", label: "Latest salary slip / income proof ready?" },
            { id: "loan_statements", label: "All loan statements (last 3 months) ready?" },
            { id: "card_statements", label: "Credit card statements (last 3 months) ready?" },
            { id: "cibil_report", label: "CIBIL report ready?" },
            { id: "insurance_docs", label: "Insurance policy documents ready?" },
            { id: "bank_statement", label: "Primary bank statement (last 3 months) ready?" },
        ],
    },
];

export default function SamvadForm() {
    return (
        <QuestionnaireShell
            title="Samvad Pre-Consultation"
            tagline="Samvad · 1-on-1 Consultation · ₹3,969"
            packageKey="samvad"
            sections={sections}
        />
    );
}
